import LoungeRow from './LoungeRow';
export default LoungeRow;
